export const MAILS = 'md_mails_GLOBAL';